import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { TrendingDown, AlertCircle } from 'lucide-react';
export function SellingOutWidget() {
  const [stockCount, setStockCount] = useState(1313);
  const [recentSales, setRecentSales] = useState(0);
  // Total stock set so that 1313 represents ~20% remaining (80% sold)
  const totalStock = 6565;
  const stockPercentage = stockCount / totalStock * 100;
  useEffect(() => {
    // Decrease stock count every 8-15 seconds
    const stockInterval = setInterval(() => {
      setStockCount(prev => {
        // When it reaches 600, reset to 1313
        if (prev <= 600) {
          return 1313;
        }
        const newCount = prev - Math.floor(Math.random() * 3) - 1;
        return newCount;
      });
    }, Math.random() * 7000 + 8000);
    // Show recent sales notifications
    const salesInterval = setInterval(() => {
      setRecentSales(Math.floor(Math.random() * 4) + 1);
      setTimeout(() => setRecentSales(0), 3000);
    }, Math.random() * 10000 + 15000);
    return () => {
      clearInterval(stockInterval);
      clearInterval(salesInterval);
    };
  }, []);
  return <div className="relative" data-id="element-365">
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="bg-gradient-to-r from-red-50 to-orange-50 border-2 border-red-200 rounded-xl p-4 shadow-lg" data-id="element-366">
        {/* Header */}
        <div className="flex items-center justify-between mb-3" data-id="element-367">
          <div className="flex items-center gap-2" data-id="element-368">
            <motion.div animate={{
            scale: [1, 1.2, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} data-id="element-369">
              <AlertCircle className="w-5 h-5 text-red-600" data-id="element-370" />
            </motion.div>
            <span className="font-bold text-red-900 text-sm" data-id="element-371">
              SELLING OUT FAST
            </span>
          </div>
          <div className="flex items-center gap-1.5 text-red-700" data-id="element-372">
            <TrendingDown className="w-4 h-4" data-id="element-373" />
            <span className="text-xs font-semibold" data-id="element-374">Live Stock</span>
          </div>
        </div>

        {/* Stock Counter */}
        <div className="mb-3" data-id="element-375">
          <div className="flex items-baseline gap-2 mb-2" data-id="element-376">
            <span className="text-gray-700 text-sm" data-id="element-377">Only</span>
            <AnimatePresence mode="wait" data-id="element-378">
              <motion.span key={stockCount} initial={{
              y: -20,
              opacity: 0
            }} animate={{
              y: 0,
              opacity: 1
            }} exit={{
              y: 20,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="text-3xl font-bold text-red-600" data-id="element-379">
                {stockCount}
              </motion.span>
            </AnimatePresence>
            <span className="text-gray-700 text-sm" data-id="element-380">bottles left</span>
          </div>

          {/* Progress Bar */}
          <div className="relative h-3 bg-gray-200 rounded-full overflow-hidden" data-id="element-381">
            <motion.div className="absolute inset-y-0 left-0 bg-gradient-to-r from-red-500 to-orange-500 rounded-full" animate={{
            width: `${stockPercentage}%`
          }} transition={{
            duration: 0.5
          }} data-id="element-382" />
            <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent" animate={{
            x: ['-100%', '200%']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-383" />
          </div>
        </div>

        {/* Recent Sales Notification */}
        <AnimatePresence data-id="element-384">
          {recentSales > 0 && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="bg-white/80 backdrop-blur-sm rounded-lg px-3 py-2 border border-red-200" data-id="element-385">
              <div className="flex items-center gap-2" data-id="element-386">
                <motion.div animate={{
              scale: [1, 1.1, 1]
            }} transition={{
              duration: 0.5
            }} className="w-2 h-2 bg-red-500 rounded-full" data-id="element-387" />
                <span className="text-xs text-gray-700" data-id="element-388">
                  <strong data-id="element-389">{recentSales}</strong>{' '}
                  {recentSales === 1 ? 'person' : 'people'} just ordered
                </span>
              </div>
            </motion.div>}
        </AnimatePresence>
      </motion.div>
    </div>;
}